import React, { createContext, useContext, useState, ReactNode } from "react";
import { CountryCode } from "../utils/Constants";

interface BookingContextType {
  phoneNumber: string;
  countryPrefix: CountryCode;
  setPhoneNumber: (phoneNumber: string) => void;
  setCountryPrefix: (countryPrefix: CountryCode) => void;
  setBookingUserInfo: (phoneNumber: string, countryPrefix: CountryCode) => void;
  clearBookingInfo: () => void;
}

const BookingContext = createContext<BookingContextType>({
  phoneNumber: "",
  countryPrefix: CountryCode.HONG_KONG,
  setPhoneNumber: () => {},
  setCountryPrefix: () => {},
  setBookingUserInfo: () => {},
  clearBookingInfo: () => {},
});

export const useBooking = () => useContext(BookingContext);

export const BookingProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [phoneNumber, setPhoneNumberState] = useState<string>(() => localStorage.getItem("userPhoneNumber") || "");
  const [countryPrefix, setCountryPrefixState] = useState<CountryCode>(() => {
    const savedPrefix = localStorage.getItem("countryPrefix") as CountryCode;
    return savedPrefix ?? CountryCode.HONG_KONG;
  });

  const setPhoneNumber = (newPhoneNumber: string) => {
    setPhoneNumberState(newPhoneNumber);
    localStorage.setItem("userPhoneNumber", newPhoneNumber);
  };

  const setCountryPrefix = (newCountryPrefix: CountryCode) => {
    setCountryPrefixState(newCountryPrefix);
    localStorage.setItem("countryPrefix", newCountryPrefix);
  };

  const setBookingUserInfo = (newPhoneNumber: string, newCountryPrefix: CountryCode) => {
    setPhoneNumber(newPhoneNumber);
    setCountryPrefix(newCountryPrefix);
  };

  const clearBookingInfo = () => {
    setPhoneNumberState("");
    setCountryPrefixState(CountryCode.HONG_KONG);

    localStorage.removeItem("userPhoneNumber");
    localStorage.removeItem("countryPrefix");
  };

  return (
    <BookingContext.Provider
      value={{
        phoneNumber,
        countryPrefix,
        setPhoneNumber,
        setCountryPrefix,
        setBookingUserInfo,
        clearBookingInfo,
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};